<template>
  <div>
    <img src="../assets/anchorReadBg.png" style="width: 100%;" />
    <div class="contentBg">
      <p class="title">1. 主播應堅持正確政治方向、輿論導向與價值取向，傳播正能量，弘揚優秀文化，自覺維護國家利益、公共利益與社會公序良俗。</p>
      <p class="title">2. 主播須遵守實名認證規定，提供真實身份資訊，不得冒用、出借、出租或轉讓帳號，平台每六個月覆核身份資料。</p>
      <p class="title">3. 主播應恪守職業道德，尊重他人權益，杜絕低俗內容，抵制流量至上、畸形審美、飯圈亂象，共同維護健康直播環境。</p>
      <p class="title">4. 主播開播前應熟知平台規則與當地法令，接受平台監督，並對自身直播內容與行為承擔全部責任。</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  document.title = '主播須知'
})
</script>

<script>
export default {
  name: 'AnchorRead'
}
</script>

<style scoped>
.contentBg{
position: absolute;
  top: 0px;
  left: 0px;
  margin-top: 200px;
  margin-left: 50px;
  margin-right: 50px;
}
.title {
  font-size: 16px;
  color: black;
  font-weight: medium;
  text-align: left;
  text-indent: 2em;
}
</style>